import React from "react";

const TermofUse = () => {
  return (
    <>
      {/* breadcrumb start */}
      <div
        className="cta4-section-area mkt150"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/newbg.png)",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="cta-content-area heading1">
                <h2 className="text-anime-style-3">Terms and Conditions</h2>
                <div className="space16" />
                <p>Important Terms You Should Know</p>
              </div>
            </div>
            <div className="col-lg-3" />
            <div className="col-lg-4">
              <div className="cta-circle-area">
                <div className="img1">
                  <img src="assets/img/all-images/cta/cta-img4.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
      {/* breadcrumb end */}

      <div className="w-full h4-pricing-wrapper pb-[60px] md:pb-[6rem] max-md:pt-[60px] max-md:px-[20px] md:pt-[100px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="md:px-[100px]">
              <p className="mb-[10px]">
                These Terms &amp; Conditions (“Terms”) govern your access to and
                use of the KFutureHealth website (the “Website”) and the
                SaaS-based healthtech infrastructure we provide (the “Service”).
                By accessing or using the Website or Service, you agree to be
                bound by these Terms.
              </p>
              <p className="mb-[10px]">
                <strong>1. Definitions</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  <strong>“KFutureHealth”</strong> powered by KFUTURE HEALTH SERVICES PRIVATE LIMITED.
                </p>
                <p className="mb-[10px]">
                  <strong>“You”</strong> refers to the individual or entity
                  accessing or using the Website or Service.
                </p>
                <p className="mb-[10px]">
                  <strong>“Content”</strong> refers to any information, data,
                  text, software, code, or other materials displayed on or
                  available through the Website or Service.
                </p>
                <p className="mb-[10px]">
                  <strong>“User”</strong> refers to any individual or entity who
                  accesses or uses the Website or Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>2. Use of the Website and Service</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  You may only use the Website and Service for lawful purposes
                  and in accordance with these Terms.
                </p>
                <p className="mb-[10px]">
                  You agree not to use the Website or Service:
                </p>
                <div style={{ paddingLeft: 10 }}>
                  <p className="mb-[10px]">
                    • In a manner that could damage, disable, overburden, or
                    impair the Website or Service.
                  </p>
                  <p className="mb-[10px]">
                    • To interfere with any other user’s enjoyment of the
                    Website or Service.
                  </p>
                  <p className="mb-[10px]">
                    • To gain unauthorized access to the Website or Service, or
                    any computer systems or networks connected to the Website or
                    Service.
                  </p>
                  <p className="mb-[10px]">
                    • To upload, transmit, or store any content that is
                    unlawful, harassing, defamatory, obscene, or otherwise
                    objectionable.
                  </p>
                  <p className="mb-[10px]">
                    • To violate any applicable laws or regulations.
                  </p>
                </div>
              </div>
              <p className="mb-[10px]">
                <strong>3. User Content</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  You are solely responsible for any content you upload,
                  transmit, or store on the Website or Service.
                </p>
                <p className="mb-[10px]">
                  You grant KFutureHealth&nbsp; Company a non-exclusive,
                  royalty-free license to use, reproduce, modify, publish, and
                  distribute your User Content in connection with the Website
                  and Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>4. Intellectual Property</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  The Website and Service, including all Content, are protected
                  by copyright, trademark, and other intellectual property laws.
                </p>
                <p className="mb-[10px]">
                  You agree not to remove, alter, or obscure any copyright
                  notices or other proprietary notices placed on the Website or
                  Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>5. Disclaimers</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  Welcome to kfuturehealth.com, an OPD wellness and healthcare
                  benefits platform. Please note the following important
                  information:
                </p>
                <p className="mb-[10px]">
                  •{" "}
                  <strong>
                    kfuturehealth.com is not an insurance provider, insurance
                    broker, or insurance advisor.
                  </strong>{" "}
                  <br />• The wellness plans, discounts, and services offered on
                  this platform are <strong>not insurance products </strong> and{" "}
                  <strong>should not be construed as health insurance.</strong>{" "}
                  <br />• These plans are{" "}
                  <strong>
                    not regulated by the Insurance Regulatory and Development
                    Authority of India (IRDAI).
                  </strong>{" "}
                  <br />• The benefits provided are part of a{" "}
                  <strong>value-added wellness program</strong>, intended to
                  support preventive care and general outpatient services.{" "}
                  <br />• Users are advised to{" "}
                  <strong>read all plan details carefully</strong> and consult a
                  licensed insurance advisor for any insurance-related needs.{" "}
                  <br />• kfuturehealth.com makes{" "}
                  <strong>no representation or warranty</strong> regarding claim
                  reimbursement, hospitalization cover, or insurance coverage of
                  any kind under these wellness plans.
                </p>
                <p className="mb-[10px]">
                  By using this website, you acknowledge and agree to the terms
                  of this disclaimer.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>6. Limitation of Liability</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  KFutureHealth SHALL NOT BE LIABLE FOR ANY DIRECT,
                  INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
                  DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE
                  WEBSITE OR SERVICE.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>7. Term and Termination</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  These Terms shall remain in full force and effect until
                  terminated by you or KFutureHealth.
                </p>
                <p className="mb-[10px]">
                  KFutureHealth may terminate these Terms at any time, with
                  or without cause, upon written notice to you.
                </p>
                <p className="mb-[10px]">
                  You may terminate these Terms by discontinuing your use of the
                  Website and Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>8. Governing Law</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  These Terms shall be governed by and construed in accordance
                  with the laws of India.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>9. Entire Agreement</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  These Terms constitute the entire agreement between you and KFutureHealth with respect to the use of the Website and Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>10. Severability</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  If any provision of these Terms is held to be invalid or
                  unenforceable, such provision shall be struck and the
                  remaining provisions shall remain in full force and effect.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>11. Waiver</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  No waiver of any provision of these Terms shall be deemed a
                  further or continuing waiver of such provision or any other
                  provision.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>12. Update to Terms</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  KFutureHealth may update these Terms at any time by
                  posting the amended terms on the Website. Your continued use
                  of the Website or Service following the posting of amended
                  Terms constitutes your acceptance of the amended Terms.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>13. Contact Us</strong>
              </p>
              <p className="mb-[10px]">
                If you have any questions about these Terms, please contact us
                at support@kfuturehealth.com.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermofUse;
